import React from 'react';

const PromoStrip = ({ content, mobContent }) => {
  const displayContent = window.innerWidth < 768 && mobContent ? mobContent : content;
  return (
    <div data-testid="promo-strip" className={`promo-strip `}>
      <div className="promo-strip-content-container">{displayContent}</div>
    </div>
  );
};

export { PromoStrip };
